import React, { Component } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import redirectURL from "../redirectURL";

var colors = ["#FF7F50", "#00C292","#0593AA","#A98300","#944E63","#211C6A"];
var colors1 = ["#FF7F50","#00C292", "#0593AA"];
const decipher = salt => {
  const textToChars = text => text.split('').map(c => c.charCodeAt(0));
  const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
  return encoded => encoded.match(/.{1,2}/g)
    .map(hex => parseInt(hex, 16))
    .map(applySaltToChar)
    .map(charCode => String.fromCharCode(charCode))
    .join('');
}
var decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr");
var localStorageRole = (localStorage.getItem("role"))


class ConsignmentChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [],
      plannedcount: 0,
      unplannedcount: 0,
      pendingcount: 0,
      total: 0,
      active: 0,
      delivered: 0,
      epod: 0,
      totalcount: 0,
      stoppages: 0,
      transitDelay: 0,
      ontimeDelivered: 0,
      epodPending: 0,
      inactive:0
      // overspeed:0
    };
  }

  componentDidMount() {
    this.getdata();
  }

  getdata = () => {
    var params ={}
    var location_name = localStorage.getItem("location");
    location_name = (location_name && location_name !=="undefined" && location_name !==null) ? location_name.split(",").filter(Boolean) : [];
    var locationNameConversion = location_name.map(e => e.trim().toLowerCase());
    var entity1 = localStorage.getItem("entity")
  entity1 = (entity1 && entity1 !== "undefined" && entity1.trim() !== "" && entity1 !== null) 
  ? entity1.split(",").map(x => x.trim()).filter(Boolean) 
  : [];    
  var entityConversion = entity1.map(e=> e.trim().toLowerCase())

    // if(decode(localStorageRole).toLowerCase() === "user"){
      if (
        locationNameConversion &&
        locationNameConversion.length > 0 &&
        !["all numeric shipments", "all sites", "all shipment"].some((item) => locationNameConversion.includes(item))
      ) {                
params.consigner_code =locationNameConversion;
      }
      if(entityConversion && entityConversion.length > 0 && !["all"].some((item)=> entityConversion.includes(item))){
                    
        params.truck_seal_entity = entityConversion
    } 
  // }
    // let inactive_trips=[];

    redirectURL.post('/getpiechartforftl', params).then((resp) => {
      // console.log(resp, "ftldashhh");
      
      // var records = resp.data.data;
      var records1 = resp.data.data1;

    // redirectURL.post("consignments/getTptNotAssignedConsignments", params)
    //             .then(resp => {
    //                 var records = resp.data.tpt_not_assigned_details
    //                 console.log(records, "tptrecordds");
    //                 inactive_trips.push(...records)
                    
    //             })

      
      // console.log(records, "records30");
      // if(records!='' && records!=undefined){
      //   if (localStorage.getItem("role") === "tpt"){
      //     if(localStorage.getItem('tpt_code') !== '' && localStorage.getItem('tpt_code') !== undefined){
      //       records = records.filter(e=>e.transporter_code == localStorage.getItem('tpt_code'))
      //     }
      //   }
      //   if (localStorage.getItem("role") === "warehouse"){
      //     if(localStorage.getItem('warehouse_code') !== '' && localStorage.getItem('warehouse_code') !== undefined){
      //       records = records.filter(e=>e.consignee_code === localStorage.getItem('warehouse_code'))
      //     }
      //   }
      // }
     
     

      var active = records1.filter((e) => (e.status === 2 || e.status === 3 || e.status ===1) && (e.lr_no!=="" && e.lr_no !==undefined));
      var delivered = records1.filter((e) => (e.status === 4 || e.status === 8) && (e.lr_no!=="" && e.lr_no !==undefined));
      var epoddelivered = records1.filter((e) => (e.status === 4 || e.status === 8) && (e.lr_no!=="" && e.lr_no !==undefined));
      var total = records1.filter((e) => e.lr_no !== "" && e.lr_no !== undefined)
      var epod = records1.filter((e) => e.epod_check === 1);
      var inactive = records1.filter((e) => ((e.lr_no_updated!==1 && e.invoice_no && e.tracking_type)&& (e.status ==="" || e.status ===null || e.status===1)));

      // inactive.push(inactive_trips)

      var total1 = active.length + delivered.length



      var stoppages = 0;
      var transitDelay = 0;
      var ontimeDelivered = 0;
      var epodPending = 0;
      // var overspeed = 0;

      if (total !== '' && total !== undefined) {
        stoppages = total.filter((e) => (e.tracking_type && e.enroute_exception === 1)).length
        transitDelay = total.filter((e) => e.transit_delay >0).length 
        ontimeDelivered = delivered.filter((e) => e.ontime_status === 1).length 
        epodPending = epoddelivered.filter((e) =>  (
          !e.hasOwnProperty("is_submitted_pod") || e.is_submitted_pod ==0
         
        ) && (e.status == 4)).length
        // overspeed = total.filter((e) => e.overspeeding_exception === 1).length
      }

      

      var data = [
        { name: 'Inactive', y: inactive.length },
        { name: 'Active', y: active.length },
        { name: 'Delivered', y: delivered.length },
        // {name: "E POD", y: epod.length }
      ];
      
      this.setState({ 
        series: data,
        total: total1,
        active: active,
        delivered: delivered,
        epod: epod,
        inactive: inactive,
        stoppages: stoppages,
        transitDelay: transitDelay,
        ontimeDelivered: ontimeDelivered,
        epodPending: epodPending,
        // overspeed: overspeed
      },
        ()=>{
          // console.log("series ", this.state.series)
          this.renderChart();
        }); 
    });
  }

  componentDidUpdate() {
    this.renderChart();
  }

  renderChart = () => {
    const totalCount = this.state.total.length;

    Highcharts.chart('container-c', {
      chart: {
        type: 'pie',
        custom: {},
        events: {
          render: function() {
            const chart = this,
              series = chart.series[0];
            // let customLabel = chart.customLabel;
            // let customTotalLabel = chart.customTotalLabel;

            // if (!customLabel) {
            //   customLabel = chart.customLabel =
            //     chart.renderer.label(
            //       'Consignments'
            //     )
            //       .css({
            //         color: '#000',
            //         textAnchor: 'middle'
            //       })
            //       .add();
            // }

            // if (!customTotalLabel) {
            //   customTotalLabel = chart.customTotalLabel =
            //     chart.renderer.label(
            //       totalCount
            //     )
            //       .css({
            //         color: '#000',
            //         textAnchor: 'middle'
            //       })
            //       .add();
            // }

            // const x = series.center[0] + chart.plotLeft,
            //   y = series.center[1] + chart.plotTop - customLabel.attr('height') / 2;

            // customLabel.attr({
            //   x,
            //   y
            // });

            // customTotalLabel.attr({
            //   x,
            //   y: y + 20
            // });

            // customLabel.css({
            //   fontSize: `${series.center[2] / 12}px`
            // });

            // customTotalLabel.css({
            //   fontSize: `${series.center[2] / 10}px`
            // });
          }
        }
      },
      accessibility: {
        point: {
          valueSuffix: ''
        }
      },
      title: {
        text: ''
      },
      subtitle: {
        text: ''
      },
      tooltip: {
        pointFormat: '{series.name}: {point.y:.0f} <b>({point.percentage:.0f}%)</b>'
      },
      legend: {
        enabled: false
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: 'pointer',
          // borderRadius: 8,
          dataLabels: [
            {
              enabled: false,
              distance: 20,
              format: '{point.name}'
            },
            {
              enabled: false,
              distance: -15,
              format: '{point.y:.0f}',
              style: {
                fontSize: '0.9em'
              }
            }
          ],
          showInLegend: true
        }
      },
      colors: colors1,
      series: [{
        name: 'Orders',
        colorByPoint: true,
        innerSize: '45%',
        data: this.state.series,
      }],
      credits: false
    });
  };

  render() {
    
    return (
      <div className="card row h-100">
        <div className="card-body">
          <div className="d-flex flex-row justify-content-between align-items-center w-100 pb-2 pr-5">
            <div className="ml-4 mt-2 font-weight-bold d-flex flex-row justify-content-center align-items-baseline" >
              <span className="ml-2 f18">FTL Summary</span>
            </div>
          </div>

          <div className="d-flex flex-row justify-content-between align-items-center leFadeInLeft w-100 pr-1">
            <div className='col-sm-6'>
              <div id="container-c" style={{ height: '300px', width: '100%' }}></div>
            </div>
            <div className='col-sm-6'>
              <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
                <ul className="chart-info">
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[3],cursor:'pointer' }} onClick={() => window.location.href = "consignments/all_consignments"}>
                    Total
                    <span>{this.state.total}</span>
                  </li >
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[0],cursor:'pointer' }} onClick={() => window.location.href = "consignments/inactive_consignments"}>
                    In Active
                    <span>{this.state.inactive.length}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[1], cursor: 'pointer' }} onClick={() => window.location.href = "consignments/active_consignments"}>
                    Active
                    <span>{this.state.active.length}</span>
                  </li>
                  <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[2],cursor:'pointer' }} onClick={() => window.location.href = "consignments/delivered_consignments"}>
                    Delivered
                    <span>{this.state.delivered.length}</span>
                  </li>
                  {/* <li className="py-2 d-flex flex-row justify-content-between align-items-center cursor-pointer" style={{ color: colors[2],cursor:'pointer' }} onClick={() => window.location.href = "dipatchplanhistory?"+'Epod'}>
                    E POD
                    <span>{this.state.epod.length}</span>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="col-sm-12">
            <div className="d-flex flex-column justify-content-center leFadeInLeft pl-3 pr-4 mr-4 donut-content-sec">
              <div className="row">
                <div className="col card card-bx">
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display:"flex", flexDirection:"column", justifyContent:"space-evenly" }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>Stoppages</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.stoppages}</div>
                  </div>
                </div>

                <div className="col card card-bx" style={{ padding: '10px' }}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display:"flex", flexDirection:"column", justifyContent:"space-evenly" }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>Transit Delay</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold'}}>{this.state.transitDelay}</div>
                  </div>
                </div>

                <div className="col card card-bx" style={{ padding: '10px' }}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display:"flex", flexDirection:"column", justifyContent:"space-evenly" }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>Ontime Delivered</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold' }}>{this.state.ontimeDelivered}</div>
                  </div>
                </div>

                <div className="col card card-bx" style={{ padding: '10px' }}>
                  <div className="card-body" style={{ color: colors[5], textAlign: 'center', padding: '10px', display:"flex", flexDirection:"column", justifyContent:"space-evenly" }}>
                    <h6 style={{ marginBottom: '5px', fontSize: '16px' }}>EPOD Pending</h6>
                    <div style={{ fontSize: '18px', fontWeight: 'bold'}}>{this.state.epodPending}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default ConsignmentChart;
